import {useEffect} from "react";
import {batch, useSignal} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import {postSubmit, isEmpty, scrollToComponent, stringToDate} from "@ui-seeker/utils";
import {FORMAT_DATE_BACK, formatDate} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import { evolutionDataFilters } from "../../@signals";


export default function useMarketplacesLostBuyBoxEvolutionData() {
	const { showToast } = useAppToast()

	const dataEvolution = useSignal([])
	const dataEvolutionKeys = useSignal([])
	const dataEvolutionColors = useSignal({})
	const skuName = useSignal("")
    const dateRange = useSignal([])
	const isLoadingDataEvolution = useSignal(false)

    useEffect(() => {
		if (!isEmpty(evolutionDataFilters.value)) batch(() => {
			isLoadingDataEvolution.value = true
            dataEvolution.value = {}
			showToast.promise(postSubmit(`${WEBBACK_V2_API}/marketplaces/lose-buy-box-details/evolution`, evolutionDataFilters.value).then(res => batch(() => {
                dataEvolution.value = res.chartData
				dataEvolutionKeys.value = res.chartKeys
				dataEvolutionColors.value = res.chartColors
				skuName.value = res.skuName
                dateRange.value = [stringToDate(evolutionDataFilters.value.startDate), stringToDate(evolutionDataFilters.value.endDate)]
                isLoadingDataEvolution.value = false
			})).catch(() => showToast.error()
            ).finally(() => scrollToComponent('evolution-chart')))
		}) 

		if (isEmpty(evolutionDataFilters.value)) batch( () => {
			dataEvolution.value = {}
			dataEvolutionKeys.value = {}
			dataEvolutionColors.value = {}
			skuName.value = ""
		})

	}, [JSON.stringify(evolutionDataFilters.value)]);

    const onChange = (e) => {
        batch(() => {
            dateRange.value = e
            evolutionDataFilters.value = {
                ...evolutionDataFilters.value,
                startDate: formatDate(e[0], { format: FORMAT_DATE_BACK }),
                endDate: formatDate(e[1], { format: FORMAT_DATE_BACK }),
            }
        })
    }

    const resetEvolutionData = () => batch(() => {
		dataEvolution.value = {}
		dataEvolutionKeys.value = {}
		dataEvolutionColors.value = {}
		skuName.value = ""
		evolutionDataFilters.value = {}
		scrollToComponent('table-details')
	})

	return {
		dataEvolution: dataEvolution.value,
		isLoadingDataEvolution: isLoadingDataEvolution.value,
		dataEvolutionKeys: dataEvolutionKeys.value,
		dataEvolutionColors: dataEvolutionColors.value,
		skuName: skuName.value,
        dateRange: dateRange.value,

        onChange,
        resetEvolutionData
	}
}